import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main.component';
import { MetafrenzyGuard } from 'ngx-metafrenzy';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [MetafrenzyGuard],
    data: {
      metafrenzy: {
        title: $localize`:@@metadataMainTitle:Wipperoz - The services community`,
        tags: [
          {
            name: 'description',
            content: $localize`:@@metadataMainDescription:Discover Wipperoz, the services community. We will connect you with the right person to work online or onsite`
          },
          { name: 'url', content: $localize`:@@metadataMainUrl:https://www.wipperoz.com/en/` },
          { name: 'og:url', content: $localize`:@@metadataMainUrl:https://www.wipperoz.com/en/` },
          {
            name: 'og:image',
            content: $localize`:@@metadataMainOgImage:https://com-wipperoz-content-prd.s3.amazonaws.com/public/landing/meta/ogimage.png`
          },
          { name: 'og:title', content: $localize`:@@metadataMainOgTitle:Wipperoz - The services community` },
          {
            name: 'og:description',
            content: $localize`:@@metadataMainOgDescription:Discover Wipperoz, the services community. We will connect you with the right person to work online or onsite`
          },
          { name: 'twitter:creator', content: '@wipperoz' },
          {
            name: 'twitter:image',
            content: $localize`:@@metadataMainTwitterImage:https://com-wipperoz-content-prd.s3.amazonaws.com/public/landing/meta/twitterimage.png`
          },
          { name: 'twitter:card', content: 'summary_large_image' },
          {
            name: 'twitter:title',
            content: $localize`:@@metadataMainTwitterTitle:Wipperoz - The services community`
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:site',
            content: '@wipperoz'
          },
          {
            name: 'twitter:description',
            content: $localize`:@@metadataMainTwitterDescription:Discover Wipperoz, the services community. We will connect you with the right person to work online or onsite`
          },
          { name: 'robots', content: 'index, follow' },
          { name: 'author', content: 'Wipperoz pty ltd' },
          { name: 'date', content: new Date().toLocaleDateString('en-AU'), scheme: 'YYYY-MM-DD' },
          { name: 'charset', content: 'UTF-8' }
        ]
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}
